/** @format */
const loglevel = require("loglevel");
const prefix = require("loglevel-plugin-prefix");

prefix.reg(loglevel);

const getLogger = (namespace, prefixOptions, prefixOptout = true) => {
  const log = loglevel.getLogger(namespace);
  const level = loglevel.levels["INFO"] || loglevel.levels.DEBUG;

  // These level sets can be put in a common module, for example. loglevel will
  // apply them when the same getLogger constant is provided.
  log.setLevel(level);

  if (prefixOptout) {
    prefix.apply(
      log,
      prefixOptions || {
        template: `[%t] %l (${namespace}):`,
        levelFormatter(level) {
          return level.toUpperCase();
        },
        timestampFormatter(date) {
          return date.toISOString();
        }
      }
    );
  }

  return log;
};

export default getLogger;
